// lib/auth/token.ts
import { useAuthStore } from "@/stores/useAuthStore";

type PersistedAuthState = {
  state?: {
    token?: string | null;
  };
};

export function getAccessToken(): string | null {
  if (typeof window === "undefined") return null;

  const tokenFromStore = useAuthStore.getState().token;
  if (tokenFromStore) return tokenFromStore;

  const raw = localStorage.getItem("auth-storage");
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as PersistedAuthState;
    return parsed?.state?.token ?? null;
  } catch (error) {
    console.error("Failed to parse auth-storage", error);
    return null;
  }
}

export function setAuthCookie(token: string) {
  document.cookie = `token=${token}; path=/; max-age=86400; SameSite=Lax`;
}

export function clearAuthCookie() {
  document.cookie =
    "token=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Lax";
}